// React
import React from 'react';

// Packages
import cc from 'classcat';
import AnimateHeight from 'react-animate-height';

// Utilities
import { useLabels } from 'utilities/hooks';

// Components
import { FormFields } from 'components/_inputs';

const ResultChoice = ({
    Name,
    methods = null,
    fieldName = null,
    form,
    isActive,
    item,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { pickList, object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function onChoice(item) {
        form.reset({}, { keepDirty: false, keepValues: false });
        setTimeout(() => {
            form.setValue('Choice', item, {
                shouldDirty: methods ? false : true,
            });
        }, 100);
    }

    // ///////////////////
    // DATA
    // ///////////////////

    const m = methods
        ? { object: object.config(methods), options: pickList(methods) }
        : {};

    const choice = {
        title: object.config(
            `Initiative_Result__c___Initiative_Result_Type__c.${Name}`
        ).label,
        description: object.config(
            `Initiative_Result__c___Initiative_Result_Type__c.${Name}`
        ).subLabel,
        ...m,
    };

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <div onClick={() => onChoice(item)}>
            <div
                className={cc([
                    'p-16 cursor-pointer rounded-8 transition-default',
                    {
                        'border border-teal-20 hover:border-teal-40': !isActive,
                        'border-2 border-teal-40': isActive,
                    },
                ])}>
                <h5
                    className={cc([
                        'mb-4 t-h5 transition-default',
                        {
                            'text-teal-60': !isActive,
                            'text-teal-100': isActive,
                        },
                    ])}>
                    {choice.title}
                </h5>
                <p className="text-teal-80 t-caption">{choice.description}</p>
                {choice?.options?.length > 0 && (
                    <>
                        <div onClick={event => event.stopPropagation()}>
                            <AnimateHeight
                                className="mt-24"
                                duration={300}
                                animateOpacity={true}
                                height={isActive ? 'auto' : 0}>
                                <FormFields
                                    {...{
                                        fields: [
                                            {
                                                type: 'Select',
                                                name: fieldName,
                                                sort: false,
                                                object: {
                                                    ...choice.object,
                                                },
                                                options: choice.options,
                                            },
                                        ],
                                        form,
                                    }}
                                />
                            </AnimateHeight>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ResultChoice;
